import { SingleSelectDropdownProps, SingleSelectDropdown } from '@tableau/widgets';
import { useField, FormikProps, FormikValues, useFormikContext, FormikContextType } from 'formik';
import React from 'react';
import ReactDOM = require('react-dom');

export type FormikSingleSelectDropdownProps = Omit<SingleSelectDropdownProps, 'onChange'> & {name: string};

/**
 * A wrapper around {@link SingleSelectDropdown} which auto-wires to a {@link Formik} field using the `name`
 * prop. The props are identical to {@link SingleSelectDropdown}, except that the change
 * handler are calculated automatically. It is still possible to supply them in props to override the default behavior.
 */
export function FormikSingleSelectDropdown(props: FormikSingleSelectDropdownProps) {
  const [field, meta, helpers] = useField(props.name);
  const form: FormikContextType<any> = useFormikContext();

  const changeHandler = React.useCallback((value: string) => {
    helpers.setValue(value);
  }, [helpers.setValue]);

  const handleButtonRef = (ref: HTMLButtonElement | null) => {
    let buttonEl = ref ? ReactDOM.findDOMNode(ref) as HTMLElement : undefined;
    if (buttonEl) {
      buttonEl.setAttribute('name', props.name);
      buttonEl.setAttribute('type', 'button');
    }
  };

  return (
    <SingleSelectDropdown list={props.list}
                          onChange={changeHandler}
                          value={field.value}
                          disabled={form.isSubmitting}
                          buttonRef={handleButtonRef}
                          {...props}
    />
  );
}
